var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.lazyLoad)?_c('img',_vm._g(_vm._b({directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.imgSrc),expression:"imgSrc"}],key:_vm.imgSrc,staticClass:"AcspImage lazyLoad"},'img',_vm.$attrs,false),_vm.$listeners)):_c('img',_vm._g(_vm._b({key:_vm.imgSrc,staticClass:"AcspImage",attrs:{"src":_vm.imgSrc}},'img',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }